import ThermalPrintService from "./ThermalPrintService";

export function enableThermalPrinterMock() {
  return ThermalPrintService.enableMockMode();
}

export function disableThermalPrinterMock() {
  return ThermalPrintService.disableMockMode();
}

export function initThermalPrinterMock() {
  const service = ThermalPrintService.getInstance();
  if (service.isMockMode()) {
    service._mockConnect();
    console.info(
      "[ThermalPrint Mock] Dev mock printer active (Mock Thermal Printer)."
    );
  }
}
